module.exports = __webpack_public_path__ + "static/media/sun-country-header.53695957.png";